// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "cookbook-" + chunkId + ".js?v=" + {"vendors-node_modules_rehype-highlight_index_js":"916d1f7a3bc4a106c6e8","node_modules_nextcloud_dialogs_dist_chunks_index-Ly0obkwS_mjs":"fc183286eef494e3523c","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-CSmrMOEO_mjs":"be12b3042d7c59cf630e"}[chunkId] + "";
};